import { render, staticRenderFns } from "./ContactDistributionsByOwner.vue?vue&type=template&id=4beb2a50&scoped=true"
import script from "./ContactDistributionsByOwner.vue?vue&type=script&lang=js"
export * from "./ContactDistributionsByOwner.vue?vue&type=script&lang=js"
import style0 from "./ContactDistributionsByOwner.vue?vue&type=style&index=0&id=4beb2a50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beb2a50",
  null
  
)

export default component.exports